import { defineComponent as a, computed as o, createBlock as c, openBlock as i, resolveDynamicComponent as f, mergeProps as u, withCtx as d, createVNode as m, createElementVNode as p, normalizeClass as s, renderSlot as w } from "vue";
import _ from "./Icon.js";
import { _ as v } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const h = /* @__PURE__ */ a({
  name: "ll-icon-label",
  __name: "IconLabel",
  props: {
    icon: {},
    color: { default: void 0 },
    href: { default: void 0 },
    to: { default: void 0 },
    stacked: { type: Boolean, default: !1 },
    truncate: { type: Boolean, default: !1 }
  },
  setup(n) {
    const e = n, r = o(() => e.to ? "router-link" : e.href ? "a" : "div"), l = o(() => e.to ? {
      to: e.to
    } : e.href ? {
      href: e.href
    } : {});
    return (t, b) => (i(), c(f(r.value), u(l.value, {
      class: ["tw-flex", { "tw-flex-col tw-items-center": e.stacked }]
    }), {
      default: d(() => [
        m(_, {
          name: e.icon,
          size: "dense",
          class: s([t.$style.icon, { [`tw-text-${t.color}`]: !!t.color }])
        }, null, 8, ["name", "class"]),
        p("div", {
          class: s({
            "tw-ml-1.5 tw-flex-1": !e.stacked,
            "tw-mt-1.5 tw-text-xs tw-leading-3": e.stacked,
            "tw-truncate": t.truncate
          })
        }, [
          w(t.$slots, "default")
        ], 2)
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), k = "_icon_gr3q2_2", y = {
  icon: k
}, x = {
  $style: y
}, g = /* @__PURE__ */ v(h, [["__cssModules", x]]);
export {
  g as default
};
//# sourceMappingURL=IconLabel.js.map
